// extracted by extract-css-chunks-webpack-plugin
module.exports = {"login-form":"_2mx_v","loginForm":"_2mx_v","login-form-button":"_3_agx","loginFormButton":"_3_agx","login-input":"_2cky0","loginInput":"_2cky0"};